import {request} from "@/main";
import {IGenerateInvoice, IGenerateInvoiceResult, ITariff} from "../model";

export const getActiveOrder = async (uin: string): Promise<ITariff> => {
    return (await request.get(`/proxy/ismet-docs-api.ismet-docs/api/v1/order/active/${uin}`)).data;
}

export const getOrders = async (uin: string): Promise<ITariff[]> => {
    return (await request.get(`/proxy/ismet-docs-api.ismet-docs/api/v1/order/${uin}`)).data;
}

export const getStatus = async (hash: string | undefined) => {
    return (await request.get(`/proxy/prebill-api.prebill/api/v1/result/${hash}`)).data;
}

export const createOrder = async (tariff: string, uin: string | undefined, checkPaid: boolean = false) => {
    let params = new URLSearchParams()
    params.append('checkPaid', String(checkPaid));
    return (await request.post(`/proxy/ismet-docs-api.ismet-docs/api/v1/order/create-order/${uin}/${tariff}`, {}, {params: params})).data;
}

export const getBalance = async (filialId: any, customerAccountId: any) => {
    return (await request.get(`/proxy/prebill-api.prebill/api/v1/helper/balance/by-filial_id-customer_account_id/${filialId}/${customerAccountId}`)).data;
}

export const generateInvoiceForPayment = async (params: IGenerateInvoice): Promise<IGenerateInvoiceResult> => {
    return (await request.post(`/proxy/documents-interceptor.bpmn/api/v1/document/payment-invoice/generate?ismetDocs=true&ismetDocsTariff=${params.isMonth ? 1 : 2}`, {
        abonentId: params.localId,
        currency: 'kzt',
        uin: params.uin,
        lang: params.lang,
        filialId: params.filialId,
        customerAccountCategoryId: params.customerAccountCategoryId,
        balance: params.balance,
    })).data;
}

export const downloadInvoiceForPayment = async (id: number) => {
    const result = (await request.get(`/proxy/documents-interceptor.bpmn/api/v1/document/payment-invoice/get-file-by-id/${id}`, { responseType: 'arraybuffer' }));
    return {
        data: new Blob([result.data], {type: "octet/stream"}),
        name: result.headers['content-disposition']?.match(/filename=([a-zA-Z0-9а-яА-Я.-]+)/i)?.[1] ?? 'invoice.pdf',
    };
}

export const getPathInvoiceForPayment = async (id: number) => {
    const path = (await request.get(`/proxy/documents-interceptor.bpmn/api/v1/document/payment-invoice/generate-path/${id}`)).data;
    return `/proxy/documents-interceptor.bpmn/api/v1/document/payment-invoice/public/by-path?path=${path}&download=true`;
}
